import type { ReactNode } from 'react'
import { DatOneIcon } from '@/features/load-hub/icons/SourceIcons'
import { SOURCE_ICONS } from '@/features/load-hub/components/filters/SourcesSelect'

const BOX_TRUCK_DAT_ICON_SIZE = 30

export const isBoxTruckDatSource = (sourceKey: string): boolean => sourceKey === 'DAT' || sourceKey === 'DAT_EXTENSION'

export const BoxTruckSourceIcon = ({ sourceKey, fallback = null }: { sourceKey: string; fallback?: ReactNode }) => {
    if (isBoxTruckDatSource(sourceKey)) {
        return (
            <span className="inline-flex h-4 w-4 shrink-0 items-center justify-center overflow-visible">
                <DatOneIcon size={BOX_TRUCK_DAT_ICON_SIZE} />
            </span>
        )
    }
    if (sourceKey === 'SYLECTUS') {
        return (
            <span className="inline-flex h-4 w-4 shrink-0 items-center justify-center overflow-visible">
                <span className="inline-flex scale-[1.4]">{SOURCE_ICONS[sourceKey]}</span>
            </span>
        )
    }
    return <>{SOURCE_ICONS[sourceKey] ?? fallback}</>
}
